import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';
import { companionsKeys, type CompanionDto } from './companions';
import { scheduleRewardRefetch } from './rewardRefetch';

// The wash (spec 2026-08-23 §6.3 / Task 14's WashController) — a DEDICATED endpoint, not a
// fourth CareService action (D5: no care stat is ever touched). Same bare-fetcher-plus-hook
// shape as care.ts's postCareAction/useCareAction, but with NO optimistic update: the
// three-stage gesture is client-side (washStages.ts), and this single call at the end clears
// every stain server-side in one shot — there is nothing plausible to guess at client-side in
// the meantime, unlike useCareAction's predictable free-play joy boost.
export const postWash = (companionId: number) =>
  apiFetch<CompanionDto>(`/companions/${companionId}/wash`, { method: 'POST' });

export function useWash(companionId: number) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => postWash(companionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: companionsKeys.all });
      scheduleRewardRefetch(queryClient); // QA 2026-09-23 bug 1 — same outbox lag as care.ts
    },
  });
}
